export default {
  ORDER: 'order_event',
  SHIPMENT: 'shipment_event',
  TIMELINE: 'timeline_state',
};